import React, { createContext, ReactNode, useMemo } from "react";
import { fetcher } from "services/apiClient";
import useSWR from "swr";

export interface IFolder {
  id: string;
  name: string;
  orderNumber: number;
  amount: number;
}

export const FoldersContext = createContext(undefined);

export const FoldersProvider = ({ children }: { children: ReactNode }) => {
  const { data, error, mutate } = useSWR<IFolder[]>(`/folders/list`, fetcher, {
    refreshInterval: 0,
  });

  const value = useMemo(
    () => ({
      folders: data,
      isFoldersLoading: !data && !error,
      isFoldersError: !!error,
      mutateFolders: mutate,
    }),
    [data, error, mutate]
  );

  return (
    <FoldersContext.Provider value={value}>{children}</FoldersContext.Provider>
  );
};
